<template>
  <div class="menu-wrapper">
    <div class="menu-item" v-for="(item,index) in menuData" :key="index">
      <div
        class="first-menu"
        @click="navigationTo(item.path,item)"
        :class="{'not-border':menuData[index-1]&&!menuData[index-1].child}"
      >
        <span>{{item.name}}</span>
      </div>
      <div v-if="item.child" class="innerItem-wrapper">
        <div
          class="second-menu"
          v-for="(innerItem,innerIndex) in item.child"
          :key="innerIndex"
          :class="{'active':path ===innerItem.path || (innerItem.activePaths && innerItem.activePaths.includes(path)) }"
          @click="navigationTo(innerItem.path,innerItem)"
        >
          <span>{{innerItem.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { karmaUrl } from '@/config'
export default {
  data () {
    return {
      menuData: [
        { name: '控制台', path: '/console' },
        // { name: 'Karma业务情报搜索引擎', path: '', outerChain: karmaUrl },
        { name: '数据产品', child: [{ name: '手机号画像', path: '/riskPhone', activePaths: ['/phoneFeedback'] }, { name: '风险IP画像', path: '/riskIp' }, { name: '风险设备画像', path: '/riskDevice' }] },
        // { name: '移动风险感知平台', path: '/riskMobile' },
        { name: '配置', path: '/configure' }
      ]
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  },
  methods: {
    navigationTo (path, item) {
      if (item.outerChain) {
        window.open(item.outerChain)
        return
      }
      if (!path) {
        path = item.child[0].path
      }
      if (this.path === path) return
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-wrapper {
  width: 220px;
  background: rgba(0, 5, 17, 1);
  display: flex;
  flex-direction: column;
  color: #ffffff;
}
.menu-item {
  .first-menu {
    height: 56px;
    line-height: 56px;
    background: rgba(28, 32, 44, 1);
    border: 1px solid rgba(68, 71, 85, 1);
    box-sizing: border-box;
    padding-left: 36px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    // &.not-border {
    //   border-top: 0;
    // }
  }
  .innerItem-wrapper {
    .second-menu {
      height: 48px;
      line-height: 48px;
      padding-left: 52px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      &.active {
        background: linear-gradient(
          270deg,
          rgba(43, 74, 122, 1) 0%,
          rgba(86, 129, 178, 1) 100%
        );
        position: relative;
        ::after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 8px;
          background: rgba(233, 242, 255, 1);
        }
      }
    }
  }
}
</style>
